import theme from '@theme-ui/preset-tailwind';

export const images = {
  ...(theme.images && theme.images),
};
